import { render, staticRenderFns } from "./LegalFooter.vue?vue&type=template&id=b39a510c&"
import script from "./LegalFooter.vue?vue&type=script&lang=js&"
export * from "./LegalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports